export const SET_STORE_DELIVERY = "SET_STORE_DELIVERY";
export const SET_STORE_COLLECTION = "SET_STORE_COLLECTION";
export const SET_SELECTED_STORE = "SET_SELECTED_STORE";
export const SET_DOMAIN_SETTING = "SET_DOMAIN_SETTING";
export const SET_ALL_STORE = "SET_ALL_STORE";
export const SET_ALL_CATEGORY = "SET_ALL_CATEGORY";
export const SET_STORE_TYPE = "SET_STORE_TYPE";
export const SET_FEATURED_ITEM = 'SET_FEATURED_ITEM'
export const SET_STORE_PICKUP_DATE = 'SET_STORE_PICKUP_DATE'
export const SET_STORE_CLOSE_MODAL = 'SET_STORE_CLOSE_MODAL'
export const SET_ALL_REVIEW = 'SET_ALL_REVIEW';
export const SET_STORE_DELIVERY_PICKUP_TYPE = 'SET_STORE_DELIVERY_PICKUP_TYPE'
export const SET_SAVED_CARD = 'SET_SAVED_CARD'
export const CLEAR_SAVED_CARD = 'CLEAR_SAVED_CARD'


export const setStoreDeliveryPickupAllow = (data: any) => {
  return {
    type: SET_STORE_DELIVERY_PICKUP_TYPE,
    payload: data
  }
}

export const setStoreCloseModal = (data: any) => {
  return {
    type: SET_STORE_CLOSE_MODAL,
    payload: data
  }
}
export const SETSTOREPICKUPDATE = (data: any) => {
  return {
    type: SET_STORE_PICKUP_DATE,
    payload: data,
  };
};

export const SETALLREVIEW = (data: any) => {
  return {
    type: SET_ALL_REVIEW,
    payload: data,
  };
}
export const SETSTOREDELIVERYDATA = (data: any) => {
  return {
    type: SET_STORE_DELIVERY,
    payload: data,
  };
};
export const SETFEATUREDITEM = (data: any) => {
  return {
    type: SET_FEATURED_ITEM,
    payload: data,
  };
};
export const SETSTORETYPE = (data: any) => {
  return {
    type: SET_STORE_TYPE,
    payload: data,
  };
};
export const SETSTORECOLLECTIONDATA = (data: any) => {
  return {
    type: SET_STORE_COLLECTION,
    payload: data,
  };
};
export const SETSELECTEDSTORE = (data: any) => {
  return {
    type: SET_SELECTED_STORE,
    payload: data,
  };
};
export const SETDOMAINSETTING = (data: any) => {
  return {
    type: SET_DOMAIN_SETTING,
    payload: data,
  };
};
export const SETALLSTORE = (data: any) => {
  return {
    type: SET_ALL_STORE,
    payload: data,
  };
};
export const SETALLCATEGORY = (data: any) => {
  return {
    type: SET_ALL_CATEGORY,
    payload: data,
  };
};

export const SET_ALL_SAVED_CARD = (data: any) => {
  return {
    type: SET_SAVED_CARD,
    payload: data
  }
}

export const CLEAR_All_SAVED_CARD = () =>{
  return {
    type: CLEAR_SAVED_CARD,
    payload: []
  }
}

const initialState: object = {
  collection: [],
  delivery: [],
  allStore: [],
  allCategory: [],
  allFeaturedItem: [],
  storePickupDate: [],
  selectedStore: {},
  domain_setting: {},
  selectedType: sessionStorage.getItem("store_type"),
  allReviewList: [],
  isStoreCloseModalOpen: false,
  storeDeliveryPickupType: {
    'dinning': false,
    'pickup': false,
    'delivery': false,
    'isPickupNDelivery': true,
  },
  savedPaymentCard: [],
};

const reducer = (state = initialState, action: any) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SAVED_CARD:
      return {
        ...state,
        savedPaymentCard: payload
      };
      case CLEAR_SAVED_CARD:
        return {
          ...state,
          savedPaymentCard: []
        };
    case SET_STORE_DELIVERY:
      return {
        ...state,
        delivery: payload,
      };
    case SET_STORE_DELIVERY_PICKUP_TYPE:
      return {
        ...state,
        storeDeliveryPickupType: payload,
      }
    case SET_STORE_COLLECTION:
      return {
        ...state,
        collection: payload,
      };
    case SET_SELECTED_STORE:
      return {
        ...state,
        selectedStore: payload,
      };
    case SET_DOMAIN_SETTING:
      return {
        ...state,
        domain_setting: payload,
      };
    case SET_ALL_STORE:
      return {
        ...state,
        allStore: payload,
      };
    case SET_ALL_CATEGORY:
      return {
        ...state,
        allCategory: payload,
      };
    case SET_STORE_TYPE:
      return {
        ...state,
        selectedType: payload,
      };
    case SET_FEATURED_ITEM:
      return {
        ...state,
        allFeaturedItem: payload
      }
    case SET_STORE_PICKUP_DATE:
      return {
        ...state,
        storePickupDate: payload
      }
    case SET_ALL_REVIEW:
      return {
        ...state,
        allReviewList: payload

      }
    case SET_STORE_CLOSE_MODAL:
      return {
        ...state,
        isStoreCloseModalOpen: payload
      }

    default:
      return state;
  }
};

export default reducer;
